export default __webpack_public_path__ + "static/media/jibon-mobile-three.12af0555.png";